import { getCatalogRamSnapshotCache } from '../../../../catalog/infra/catalogRamSnapshotCache';
import { normalizeProductCode } from '../../../../catalog/domain/catalogValidation';

export function findPhysicalProductBySkuInWebCache(
  normalizedSku: string,
  organizationId: string
): { id: string; name: string; unitOfMeasure: string | null } | null {
  const row = (getCatalogRamSnapshotCache()?.products ?? []).find((p) => {
    if (p.organization_id && String(p.organization_id) !== organizationId) return false;
    if (p.is_misc === true) return false;
    if (p.item_type === 'service') return false;
    return normalizeProductCode(String(p.sku ?? '').trim()) === normalizedSku;
  });
  if (!row) return null;
  return {
    id: String(row.id),
    name: String(row.name ?? ''),
    unitOfMeasure: row.unit_of_measure != null ? String(row.unit_of_measure) : null,
  };
}
